module.exports = __webpack_public_path__ + "img/img20.4db8c7b8.svg";